import * as THREE from 'three'
import Experience from '../Experience.js'
import vertexShader   from '../../shaders/smoke/vertex.glsl'
import fragmentShader from '../../shaders/smoke/fragment.glsl'

/**
 * Smoke
 * Thin wispy smoke column rising from the wick tip.
 * Uses NormalBlending so it properly occludes and composites
 * over the background (unlike the additive flame particles).
 *
 * Positioned at the same XZ as Flame, but smoke starts ~0.9 units
 * above the flame base (at the flame tip) and rises ~1.4 units further.
 */
export default class Smoke {
    constructor(position = new THREE.Vector3(0, 0, 0)) {
        this.experience   = new Experience()
        this.scene        = this.experience.scene
        this.time         = this.experience.time

        this.count = 60
        this.initPosition = position

        this.setGeometry()
        this.setMaterial()
        this.setPoints()
    }

    setGeometry() {
        this.geometry = new THREE.BufferGeometry()

        const positions = new Float32Array(this.count * 3)
        const aSize     = new Float32Array(this.count)
        const aOffset   = new Float32Array(this.count)
        const aRandom   = new Float32Array(this.count * 3)

        for (let i = 0; i < this.count; i++) {
            const i3 = i * 3

            // Дуже вузький початок — точно над кінчиком гнота
            positions[i3]     = (Math.random() - 0.5) * 0.01
            positions[i3 + 1] = 0
            positions[i3 + 2] = (Math.random() - 0.5) * 0.01

            aSize[i]       = 0.7 + Math.random() * 0.4
            aOffset[i]     = Math.random()
            aRandom[i3]     = (Math.random() - 0.5)
            aRandom[i3 + 1] = Math.random()
            aRandom[i3 + 2] = (Math.random() - 0.5)
        }

        this.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        this.geometry.setAttribute('aSize',    new THREE.BufferAttribute(aSize,    1))
        this.geometry.setAttribute('aOffset',  new THREE.BufferAttribute(aOffset,  1))
        this.geometry.setAttribute('aRandom',  new THREE.BufferAttribute(aRandom,  3))
    }

    setMaterial() {
        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            uniforms: {
                uTime:    { value: 0 },
                uFadeOut:  { value: 1 },
                uProgress: { value: 0 },
                uSeed:     { value: Math.random() * 100.0 },
            },
            transparent: true,
            depthWrite:  false,
            blending:    THREE.NormalBlending,
        })
    }

    setPoints() {
        this.points = new THREE.Points(this.geometry, this.material)
        this.points.position.copy(this.initPosition)
        this.scene.add(this.points)
    }

    update() {
        this.material.uniforms.uTime.value = this.time.elapsed * 0.001
    }

    setFade(value) {
        this.material.uniforms.uFadeOut.value = value
    }
}
